<section class="toggle-form" [ngClass]="{ active: isCreateTrSliderOpen }">
    <div class="formwrap">
      <div class="header">        
        <h2>
          <b>{{ topBarTitle }}</b>
        </h2>
        <p-button
      appPreventDoubleClick
        styleClass="p-button-text"
        id="createTrSliderCloseButton"
        type="button"
        label="Close"
        (debounceClick)="closeCreateTrainingRequirementSlider()"
      ></p-button>       
      </div>
      <div class="general-container content">
        <div class="fields-row">
          <div class="field field-required">
            <bpt-dropdown 
            label="User(s)" 
            [options]="userList" 
            [multiSelect]="true" 
            [editable]="false"
            [(ngModel)]="selectedUsers"
            (dropdownChange)="validateUserInput()"
            id="users" 
            [showClear]="true" 
            [showFilter]="true" 
            [valueField]="valueField"
            [labelField]="labelField" 
            [ngClass]="{ 'error-highlight': mandatoryFields.users }" 
            [required]="true">
            </bpt-dropdown>
          </div>
        </div>
      </div>
      <div>
        <p-button
        appPreventDoubleClick
          label="Save"
          type="submit"
          id="createTrainingRequirementSaveButton"
          class="align-right"
          styleClass="bpt-button-compact"
          (debounceClick)="createTrainingRequirement()"
          [disabled]="!validInput"
        >
        </p-button>
      </div>
    </div>
  </section>